export function stripChapterPrefix(title: string): string {
  return title.replace(/^Chapter\s+\d+\s*[:\-–—]\s*/i, '');
}
